import { RSAKey } from 'jsrsasign';
import CryptoJS from 'crypto-js';
export default class CryptoService {
    /**
     * Sign message with the RSA private key
     */
    static signMessage(message, privateKey) {
        const rsa = new RSAKey();
        rsa.readPrivateKeyFromPEMString(privateKey);
        let signature = rsa.sign(message, 'sha256').toUpperCase();
        return signature;
    }
    /**
     * Get IIC out of the IICSignature
     */
    static getIIC(iicSignature) {
        let md5Hash = CryptoJS.MD5(CryptoJS.enc.Hex.parse(iicSignature));
        return md5Hash.toString().toUpperCase();
    }
    /**
     * Get MD5 hash of the provided string
     */
    static md5(str) {
        let md5Hash = CryptoJS.MD5(str);
        return md5Hash.toString().toUpperCase();
    }
}
//# sourceMappingURL=CryptoService.js.map